import { env } from 'shared/library/env';
import { AnalyticsEventParams } from 'shared/library/analytics/index';

function getConsentState(granted: boolean) {
  const value = granted ? 'granted' : 'denied';

  return {
    ad_user_data: value,
    ad_personalization: value,
    ad_storage: value,
    analytics_storage: value,
  };
}

export const pageView = (url: string) => {
  if (typeof window === 'undefined' || env.IS_DEV) return;

  window.gtag?.('config', env.GOOGLE_ANALYTICS_ID, {
    page_path: url,
  });

  window.fbq?.('track', 'PageView');
};

export const event = (action: string, params?: AnalyticsEventParams) => {
  if (typeof window === 'undefined' || env.IS_DEV) return;

  window.gtag?.('event', action, params);

  window.fbq?.('trackCustom', action, params);
};

export const setUserProperties = (props: Record<string, any>) => {
  if (typeof window === 'undefined' || env.IS_DEV) return;

  window.gtag?.('set', 'user_properties', props);
};

export const updateConsent = (granted: boolean) => {
  if (typeof window === 'undefined' || env.IS_DEV) return;

  window.gtag?.('consent', 'update', getConsentState(granted));
  window.fbq?.('consent', granted ? 'grant' : 'revoke');
};
